/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseRatingFieldType = {
    Icons: 'RATING_FIELD_TYPE_ICONS',
    Thumbs: 'RATING_FIELD_TYPE_THUMBS',
    School: 'RATING_FIELD_TYPE_SCHOOL',
    Nps: 'RATING_FIELD_TYPE_NPS',
    Goodbad: 'RATING_FIELD_TYPE_GOODBAD',
    Smiley: 'RATING_FIELD_TYPE_SMILEY'
} as const;
export type DatabaseRatingFieldType = typeof DatabaseRatingFieldType[keyof typeof DatabaseRatingFieldType];


export function DatabaseRatingFieldTypeFromJSON(json: any): DatabaseRatingFieldType {
    return DatabaseRatingFieldTypeFromJSONTyped(json, false);
}

export function DatabaseRatingFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseRatingFieldType {
    return json as DatabaseRatingFieldType;
}

export function DatabaseRatingFieldTypeToJSON(value?: DatabaseRatingFieldType | null): any {
    return value as any;
}

